// extracted by mini-css-extract-plugin
export var closeButton = "_gj-1";
export var closeX = "_gj-3";
export var container = "_gj-0";
export var image = "_gj-2";